module.exports = __webpack_public_path__ + "media/images/athletes/1765-b6b21cb7b5b1ffbb8b44d877e00ad58c.png";